import DodoneContext from 'app/dodones/Context'
import DodoneShowFooter from 'app/dodones/show/Footer'
import DodoneShowGenericBody from 'app/dodones/generic/show/Body'
import DodonesFields from 'app/dodones/shared/Fields'
import DodonesList from 'app/dodones/list/Index'
import HeaderContext from 'app/HeaderContext'
import DodoableDodones from 'app/dodoables/Dodones'

export default ({ children, chronometerParameters = {} }) => {
  const { dodone, updateDodone } = useContext(DodoneContext)
  const { setText } = useContext(HeaderContext)
  const [attributes, setAttributes] = useState({})

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id])

  return (
    <>
      <div className="flex-1 fcol">
        <DodoneShowGenericBody
          attributes={attributes}
          chronometerParameters={chronometerParameters}
        />
        <DodonesFields dodone={dodone} updateDodone={updateDodone} />
        {children}
        <DodonesList dodones={dodone.children} />
        {dodone.isClosed && (
          <div className="fcol flex-1" style={{ scrollY: 'auto' }}>
            <div className="text-gray-800">Previously:</div>
            <DodoableDodones
              dodoableId={dodone.dodoableId}
              limit={5}
              dodoneListItemProps={{ size: 'sm' }}
            />
          </div>
        )}
      </div>
      <DodoneShowFooter dodone={dodone} attributes={attributes} />
    </>
  )
}
